import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../common/UserContext";
import config from "../../../envconfig";
import CustomDropdown from "../../common/CustomDropdown";
import Icon3 from "../../../assest/images/Icon3.png";
function ShipInScanPendingList() {
  const {
    selectedScpId,
    UM_UserCode
  } = useContext(UserContext);
  const [userData, setUserdata] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // You can adjust the number of items per page here

  const navigate = useNavigate();
  const [navigateTo, setNavigateTo] = useState("");
  // ========================== Log File ===============================
  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Shipment Outward Scanning By Vendor :",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  //====================================================================
  const handleRowClick = (shipment) => {
    if (
      shipment.ScanningModeVendorProduct === 1 &&
      shipment.ShipmentOrderType.startsWith("New Order")
    ) {
      setNavigateTo(`/ShipInScanByVendor/${shipment.ShipmentID}`);
    } else if (shipment.ScanningModeVendorProduct === 2) {
      setNavigateTo(`/ShipInScanByProduct/${shipment.ShipmentID}`);
    } else if (
      shipment.Type === "Return" ||
      shipment.ShipmentCode.startsWith("Ret_")
    ) {
      setNavigateTo(`/ShipInReturnScan/${shipment.ShipmentID}`);
    }
  };

  useEffect(() => {
    if (navigateTo) {
      navigate(navigateTo);
    }
  }, [navigate, navigateTo]);

  useEffect(() => {
    const fetchSHIPUserData = async () => {
      try {
        const reqData = await fetch(
          `${config.API_URL}/ShipmentPendingListInward/${selectedScpId}`,
          {
            method: "GET",
          }
        );
        if (reqData.ok) {
          const resData = await reqData.json();
          console.log("Fetched data:", resData); // Log fetched data for debugging
          const uniqueShipments = removeDuplicates(
            resData.shipmentData,
            "ShipmentID"
          );
          setUserdata(uniqueShipments);
        } else {
          console.error(
            "Error fetching the shipment list:",
            reqData.statusText
          );
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };
    fetchSHIPUserData();
  }, [selectedScpId]);

  const removeDuplicates = (array, key) => {
    return array.reduce((accumulator, current) => {
      if (!accumulator.some((item) => item[key] === current[key])) {
        accumulator.push(current);
      }
      return accumulator;
    }, []);
  };

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };
  const filteredUserData = userData.filter((shipment) =>
    shipment.DeliveryNo.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // ========================================================================================================
  //                                           Filteration
  // ========================================================================================================
  const [firstFilter, setFirstFilter] = useState(""); // First filter selection
  const [firstFilterSearch, setFirstFilterSearch] = useState(""); // First filter search input
  const [secondFilter, setSecondFilter] = useState(""); // Second filter selection
  const [secondFilterSearch, setSecondFilterSearch] = useState(""); // Second filter search input
  const [statusFilter, setStatusFilter] = useState(""); // Status filter selection

  const [firstFilterOptions, setFirstFilterOptions] = useState([
    { value: "DeliveryNo", label: "Delivery Number", disabled: false },
    {
      value: "LogisticCompanyName",
      label: "Logistic Party",
      disabled: false,
    },
    { value: "VehicleNumber", label: "Vehicle Number", disabled: false },
    { value: "RouteName", label: "Route Name", disabled: false },
  ]);
  const [secondFilterOptions, setSecondFilterOptions] = useState([
    { value: "DeliveryNo", label: "Delivery Number", disabled: false },
    {
      value: "LogisticCompanyName",
      label: "Logistic Party",
      disabled: false,
    },
    { value: "VehicleNumber", label: "Vehicle Number", disabled: false },
    { value: "RouteName", label: "Route Name", disabled: false },
  ]);

  const handleFirstFilterChange = (event) => {
    const value = event.target.value;
    setFirstFilter(value);
    setFirstFilterSearch("");
    const updatedSecondOptions = secondFilterOptions.map((option) => ({
      ...option,
      disabled: option.value === value,
    }));
    setSecondFilterOptions(updatedSecondOptions);
  };
  const handleSecondFilterChange = (event) => {
    const value = event.target.value;
    setSecondFilter(value);
    setSecondFilterSearch("");
    const updatedFirstOptions = firstFilterOptions.map((option) => ({
      ...option,
      disabled: option.value === value,
    }));
    setFirstFilterOptions(updatedFirstOptions);
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [firstFilterSearch, secondFilterSearch, statusFilter]);

  const getStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      case 3:
        return "Suspend";
      default:
        return "";
    }
  };

  //
  const filteredCombinedData = userData.filter((item) => {
    const firstFilterValue = item[firstFilter];
    const secondFilterValue = item[secondFilter];
    const statusValue = getStatusLabel(item.LCM_Status);
    const containsActive = /act(ive)?/i.test(firstFilterSearch);
    const containsInactive = /inact(ive)?/i.test(firstFilterSearch);
    const matchesFirstFilter =
      !firstFilter ||
      !firstFilterSearch ||
      (firstFilter === "LCM_Status" &&
        ((containsActive && firstFilterValue === 1) ||
          (containsInactive && firstFilterValue === 2))) ||
      (firstFilter !== "LCM_Status" &&
        String(firstFilterValue)
          .toLowerCase()
          .includes(firstFilterSearch.toLowerCase()));
    const containsActive2 = /act(ive)?/i.test(secondFilterSearch);
    const containsInactive2 = /inact(ive)?/i.test(secondFilterSearch);
    const matchesSecondFilter =
      !secondFilter ||
      !secondFilterSearch ||
      (secondFilter === "LCM_Status" &&
        ((containsActive2 && secondFilterValue === 1) ||
          (containsInactive2 && secondFilterValue === 2))) ||
      (secondFilter !== "LCM_Status" &&
        String(secondFilterValue)
          .toLowerCase()
          .includes(secondFilterSearch.toLowerCase()));
    const matchesStatusFilter = !statusFilter || statusValue === statusFilter;
    return matchesFirstFilter && matchesSecondFilter && matchesStatusFilter;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPosts = filteredCombinedData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastPost = currentPage * itemsPerPage;
  const indexOfFirstPost = indexOfLastPost - itemsPerPage;

  const handleStatusFilterChange = (event) => {
    const value = event.target.value;
    setStatusFilter(value);
  };

  // ========================================================================================================
  //                                           Filteration
  // ========================================================================================================

  return (
    <>
      <div className="main_container">
        <h4 className="formHeading">Pending Inward</h4>
        <div className="row">
          <div className="mb-3">
            <div className="filter-container">
              <div className="select-container_list">
                <CustomDropdown
                  options={firstFilterOptions}
                  value={firstFilter}
                  onChange={handleFirstFilterChange}
                  name="firstFilter"
                  placeholder="--Select--"
                  idKey="value"
                  displayKey="label"
                />
              </div>
              <input
                type="text"
                className="search-input"
                value={firstFilterSearch}
                onChange={(e) => setFirstFilterSearch(e.target.value)}
                placeholder={`Search`}
              />
              <div className="select-container_list">
                <CustomDropdown
                  options={secondFilterOptions}
                  value={secondFilter}
                  onChange={handleSecondFilterChange}
                  name="secondFilter"
                  placeholder="--Select--"
                  idKey="value"
                  displayKey="label"
                />

              </div>
              <input
                type="text"
                className="search-input"
                value={secondFilterSearch}
                onChange={(e) => setSecondFilterSearch(e.target.value)}
                placeholder="Search"
              />
            </div>
          </div>
        </div>
        <div className="ptable-wrapper">
          <table className="ptableClass">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th className="">Delivery Number</th>
                <th className="">Logistic Party</th>
                <th className="">Vehicle Number</th>
                {/* <th className="">Route Name</th> */}
                <th className="">Action</th>
              </tr>
            </thead>
            <tbody>
              {currentPosts.length > 0 ? (
                currentPosts.map((shipment, index) => (
                  <tr key={index} >
                    <td>{indexOfFirstPost + index + 1}</td>
                    <td>{shipment.DeliveryNo}</td>
                    <td>{shipment.LogisticCompanyName}</td>
                    <td>{shipment.VehicleNumber}</td>
                    {/* <td>{shipment.RouteName}</td> */}
                    <td><img src={Icon3} alt="pencil" className="editicon" width={25} onClick={() => handleRowClick(shipment)}/></td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9">No Records Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {Math.ceil(filteredUserData.length / itemsPerPage) > 1 && (
          <ul className="pagination">
            {/* First Page Button */}
            <li className={currentPage === 1 || filteredUserData.length === 0 ? "page-item disabled" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(1)} disabled={currentPage === 1 || filteredUserData.length === 0}>First</button>
            </li>

            {/* Previous Page Button */}
            <li className={currentPage === 1 || filteredUserData.length === 0 ? "page-item disabled" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1 || filteredUserData.length === 0}>Previous</button>
            </li>

            {/* Page Numbers */}
            {filteredUserData.length > 0 &&
              Array.from({ length: Math.ceil(filteredUserData.length / itemsPerPage) }, (_, index) => (
                <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
                  <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
                </li>
              ))
            }

            {/* Next Page Button */}
            <li className={currentPage === Math.ceil(filteredUserData.length / itemsPerPage) || filteredUserData.length === 0 ? "page-item disabled" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredUserData.length / itemsPerPage) || filteredUserData.length === 0}>Next</button>
            </li>

            {/* Last Page Button */}
            <li className={currentPage === Math.ceil(filteredUserData.length / itemsPerPage) || filteredUserData.length === 0 ? "page-item disabled" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredUserData.length / itemsPerPage))} disabled={currentPage === Math.ceil(filteredUserData.length / itemsPerPage) || filteredUserData.length === 0}>Last</button>
            </li>
          </ul>
        )}
      </div>
      <div className="button-container">
        <Link
          to={`/dashboard/ShipmentSelectScanType`}
          className="back_btn"
          type="button"
        >
          BACK
        </Link>
        <Link to={`/ShipInScanedList`} className="list_btn" type="button">
          COMPLETED LIST{" "}
        </Link>
      </div>
    </>
  );
}

export default ShipInScanPendingList;

